import { logLevel, logUrl } from '@/data/appConfig'

import Logger from './src/Logger'

const logger = new Logger({
  appName: 'frontend',
  url: logUrl,
  level: logLevel,
})

export default logger
